(($, Drupal) => {
  Drupal.behaviors.textSlider = {
    attach: function attch(context) {
      $('.js-article-text-slider', context).once('slider').each((index, element) => {
        $(element).parents('.article-slider__list--wrapper').find('.link-overlay').on('click', () => {
          $(element).find('.slick-current .article-slider__item--link')[0].click();
        });

        $(element).on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
          const i = (currentSlide || 0) + 1;
          $('.article-slider-counter').html(`<span>${i}</span>` + '/' + `<span>${slick.slideCount}</span>`);
        });

        $(element).slick({
          arrows: true,
          prevArrow: $('.article-slider-btn.arr-left'),
          nextArrow: $('.article-slider-btn.arr-right'),
          dots: false,
          autoplay: true,
          draggable: false,
          speed: 800,
          autoplaySpeed: 5000,
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          asNavFor: '.js-article-image-slider',
          responsive: [{
            breakpoint: 768,
            settings: {
              fade: false,
              draggable: true,
              dots: true,
              asNavFor: '',
            },
          }],
        });
      });
    },
  };

  Drupal.behaviors.imageSlider = {
    attach: function attch(context) {
      $('.js-article-image-slider', context).once('slider').each((index, element) => {
        if (window.matchMedia('(min-width: 1024px)').matches) {
          $(element).slick({
            arrows: false,
            dots: false,
            draggable: true,
            speed: 1000,
            slidesToShow: 2,
            slidesToScroll: 1,
            asNavFor: '.js-article-text-slider',
          });
        }

        $(element).find('.slick-slide').on('click', function () {
          const slideIndex = $(this).index();
          setTimeout(() => {
            $(element).slick('slickGoTo', slideIndex - 2);
          }, 100);
        });

        $(element).on('click', '.slick-current', () => {
          $(element).parents('.article-slider__list--wrapper').find('.article-text-slider .slick-current .article-slider__item--link')[0].click();
        });
      });
    },
  };
})(jQuery, Drupal);
